export default __webpack_public_path__ + "static/media/image.8a443ebf.jpg";